import gql from 'graphql-tag'
import { FEED_TILE_FRAGMENT } from './feed'

import { ITEM_TILE_FRAGMENT } from './item'

export const CATEGORIES_QUERY = gql`
query categories {
  categories {
    id
    name
    medias {
      id
      path
    }
  }
}`

export const BANNERS_QUERY = gql`
query banners {
  banners {
    id
    title
    description
    media {
      id
      path
    }
  }
}`

export const VIEW_SECTION_CONNECTION = gql`
query viewSectionConnection($screenType: ViewScreenType!, $after: String) {
  viewSectionConnection(screenType: $screenType, after: $after) {
    cursor
    hasNextPage
    viewSections {
      id
      layoutType
      dataType
      dataPopulationType
      layoutOption {
        id
        title
        subtitle
        width
        height
        showProfilePicture
        showRank
        showText
        showMoreButton
        playThumbnail
        showCounts
        showFeedItem
        showUsername
        saleExpiredAt
      }
      data {
        feeds {
          ...FeedTileFragment
          saveCount
          user {
            id
            media {
              id
              path
            }
          }
          medias {
            id
            path
          }
        }
        feedsWithCustomData {
          id
          title
          feed {
            id
            medias {
              id
              path
              subMedias {
                id
                type
                ownerUseType
                path
              }
            }
          }
        }
        items {
          ...ItemTileFragment
        }
        users {
          id
          displayName
          username
          description
          isSubscribed @client
          followerCount
          shop {
            id
            status
            shoppingMallName
          }
          media {
            id
            path
          }
          latestFeed {
            id
            medias {
              id
              path
              subMedias {
                id
                type
                ownerUseType
                path
              }
            }
          }
        }
        banners {
          id
          link
          media {
            id
            type
            path
          }
        }
        categories {
          id
          name
          medias {
            id
            path
          }
        }
        categoryToItems {
          id
          category {
            id
            name
          }
          items {
            ...ItemTileFragment
          }
        }
        itemGroups {
          category {
            id
            name
            medias {
              id
              path
            }
          }
          items {
            id
            name
            price
            orgPrice
            isLiked
            medias {
              id
              path
            }
            seller {
              id
              shop {
                id
                shoppingMallName
              }
              media {
                id
                path
              }
            }
          }
        }
      }
      searchOption {
        query
        userId
        categories
        colors
        excludeSoldOuts
        showOnlyDiscountedItems
        showOnlyTimeSaleItems
        sortSpec
        minPrice
        maxPrice
      }
    }
  }
}
${FEED_TILE_FRAGMENT}
${ITEM_TILE_FRAGMENT}`
